export default __webpack_public_path__ + "static/media/Image_OB_SpeakContent_CFR@3x.b3125683.png";